import {
  APP_INITIALIZER,
  ErrorHandler,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { Router } from '@angular/router';
import { TraceService, createErrorHandler } from '@sentry/angular';

export function provideSentry() {
  return makeEnvironmentProviders([
    {
      provide: ErrorHandler,
      useValue: createErrorHandler(),
    },
    provideAppInitializer(() => {
      // necessário inicializar o traceService para que o sentry funcione
      const traceService = inject(TraceService);
      return Promise.resolve();
    }),
  ]);
}
